import posthog from "posthog-js";

export const UTM_COOKIE_NAMES = [
  "utm_id",
  "utm_name",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

type SignupEvent =
  | "signup_viewed"
  | "signup_submitted"
  | "signup_succeeded"
  | "signup_failed";

type SignupTrackingContext = {
  form: "full" | "short";
  plan?: string | null;
  period?: string | null;
  token?: string | null;
  countryCode?: string | null;
};

type SignupTrackingExtra = Record<string, string>;

function signupTrackingProperties(
  context: SignupTrackingContext,
  cookies: Record<string, unknown>,
  extra: SignupTrackingExtra = {}
) {
  const campaignProperties = UTM_COOKIE_NAMES.reduce<Record<string, string>>(
    (properties, param) => {
      const value = cookies[param];
      if (typeof value !== "string" || !value.trim()) return properties;

      properties[param] = value;
      return properties;
    },
    {}
  );

  return {
    ...campaignProperties,
    ...extra,
    signup_form: context.form,
    signup_plan: context.plan || "free",
    signup_period: context.period,
    signup_country_code: context.countryCode,
    has_invitation_token: Boolean(context.token),
  };
}

export function captureSignupEvent(
  event: SignupEvent,
  context: SignupTrackingContext,
  cookies: Record<string, unknown>,
  extra?: SignupTrackingExtra
) {
  if (!process.env.NEXT_PUBLIC_POSTHOG_KEY) return;

  posthog.capture(event, signupTrackingProperties(context, cookies, extra));
}
